import EligibilityCriteriaBox from './EligibilityCriteriaBox';

export default EligibilityCriteriaBox;
